<div class="card">
    <div class="card-header d-flex">
        <h5 class="card-title my-auto mb-auto">Agreement Types</h5>
        <button type="button" class="btn btn-primary ms-auto" (click)="updateMultiAgreementTypeOptions();">
            <fa-icon class="button-icon-left" [icon]="faSave"></fa-icon>
            <span>Save</span>
        </button>
    </div>
    <div class="card-body scrollable" style="height: 400px;">
        <!-- Single -->
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Single</h5>
                <p class="card-text">This agreement type allows you to offer a single pricing option.</p>
            </div>
        </div>
        <!-- Multi -->
        <div class="card mt-2">
            <div class="card-body">
                <h5 class="card-title">Multi Year</h5>
                <p class="card-text">This agreement type allows you to offer up to five different pricing options for multi-year contracts. For example, if you want to offer 1, 3, and 5 year contract options, then A = 1 Year, B = 3 Years, and C = 5 Years.</p>
                <div [formGroup]="multiAgreementTypeForm">
                    <!-- A -->
                    <div formGroupName="A" class="input-group">
                        <div class="input-group-text">
                            <input id="MULTI_AGREEMENT_A_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
                        </div>
                        <span class="input-group-text" style="width: 42px; display: block;">A</span>
                        <input id="MULTI_AGREEMENT_A_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="1" formControlName="numOfYears" min="1">
                        <span class="input-group-text">Year(s)</span>
                    </div>
                    <!-- B -->
                    <div formGroupName="B" class="input-group mt-2">
                        <div class="input-group-text">
                            <input id="MULTI_AGREEMENT_B_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
                        </div>
                        <span class="input-group-text" style="width: 42px; display: block;">B</span>
                        <input id="MULTI_AGREEMENT_B_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="2" min="1" formControlName="numOfYears">
                        <span class="input-group-text">Year(s)</span>
                    </div>
                    <!-- C -->
                    <div formGroupName="C" class="input-group mt-2">
                        <div class="input-group-text">
                            <input id="MULTI_AGREEMENT_C_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
                        </div>
                        <span class="input-group-text" style="width: 42px; display: block;">C</span>
                        <input id="MULTI_AGREEMENT_C_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="3" min="1" formControlName="numOfYears">
                        <span class="input-group-text">Year(s)</span>
                    </div>
                    <!-- D -->
                    <div formGroupName="D" class="input-group mt-2">
                        <div class="input-group-text">
                            <input id="MULTI_AGREEMENT_D_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
                        </div>
                        <span class="input-group-text" style="width: 42px; display: block;">D</span>
                        <input id="MULTI_AGREEMENT_D_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="4" min="1" formControlName="numOfYears">
                        <span class="input-group-text">Year(s)</span>
                    </div>
                    <!-- E -->
                    <div formGroupName="E" class="input-group mt-2">
                        <div class="input-group-text">
                            <input id="MULTI_AGREEMENT_E_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
                        </div>
                        <span class="input-group-text" style="width: 42px; display: block;">E</span>
                        <input id="MULTI_AGREEMENT_E_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="5" min="1" formControlName="numOfYears">
                        <span class="input-group-text">Year(s)</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>